var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGhost(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 10C4 5.58172 7.58172 2 12 2C16.4183 2 20 5.58172 20 10V18.4966C20 20.0217 18.3224 20.9515 17.0291 20.1432C16.3995 19.7497 15.6005 19.7497 14.9709 20.1432L13.06 21.3375C12.4115 21.7428 11.5885 21.7428 10.94 21.3375L9.02913 20.1432C8.39947 19.7497 7.60053 19.7497 6.97087 20.1432C5.67758 20.9515 4 20.0217 4 18.4966V10ZM8.95807 12.9815C8.67173 13.2808 8.68223 13.7556 8.98153 14.0419C9.7634 14.79 10.8289 15.25 12 15.25C13.1711 15.25 14.2366 14.79 15.0185 14.0419C15.3178 13.7556 15.3283 13.2808 15.0419 12.9815C14.7556 12.6822 14.2808 12.6717 13.9815 12.9581C13.4693 13.4481 12.7718 13.75 12 13.75C11.2282 13.75 10.5307 13.4481 10.0185 12.9581C9.71918 12.6717 9.24442 12.6822 8.95807 12.9815ZM9.5 11C10.0523 11 10.5 10.3284 10.5 9.5C10.5 8.67157 10.0523 8 9.5 8C8.94771 8 8.5 8.67157 8.5 9.5C8.5 10.3284 8.94771 11 9.5 11ZM14.5 11C15.0523 11 15.5 10.3284 15.5 9.5C15.5 8.67157 15.0523 8 14.5 8C13.9477 8 13.5 8.67157 13.5 9.5C13.5 10.3284 13.9477 11 14.5 11Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhost);
export default __webpack_public_path__ + "static/media/ghost.a06154f2416cc653d7ea17ac964420cc.svg";
export { ForwardRef as ReactComponent };